const theme = {
  fonts: {
    body: "'IBM Plex Sans', sans-serif",
    heading: "'IBM Plex Sans', sans-serif",
  },
  colors: {
    primary: {
      50: "#F0F4F8",
      100: "#D9E2EC",
      200: "#BCCCDC",
      300: "#9FB3C8",
      400: "#627D98",
      500: "#0C2340",
      600: "#0A1D36",
      700: "#08172C",
      800: "#061222",
      900: "#040C18",
    },
    secondary: {
      50: "#FAF9F7",
      100: "#F5F3F0",
      200: "#E8E4DE",
      300: "#D8D1C7",
      400: "#C5BCB0",
      500: "#A39A8E",
      600: "#847B70",
      700: "#666057",
      800: "#4A453F",
      900: "#2E2B27",
    },
    korall: {
      50: "#FFF0EE",
      100: "#FFD5CF",
      200: "#FFAB9F",
      300: "#F28375",
      400: "#E86D5F",
      500: "#E35F50",
      600: "#CC4E40",
      700: "#B03D31",
      800: "#932D24",
      900: "#761E18",
    },
    green: {
      50: "#EFF5F3",
      100: "#D5E5DF",
      200: "#AECBBE",
      300: "#87B09E",
      400: "#6C9887",
      500: "#507F70",
      600: "#426A5D",
      700: "#35554B",
      800: "#284038",
      900: "#1C2C26",
    },
  },
  styles: {
    global: {
      body: {
        bg: "#F5F3F0",
        color: "#2B2F33",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        transition: "none",
        borderRadius: "4px",
        fontWeight: "medium",
      },
    },
    Heading: {
      baseStyle: {
        color: "#0C2340",
        fontWeight: "semibold",
      },
    },
    Link: {
      baseStyle: {
        color: "korall.500",
        _hover: {
          color: "korall.600",
        },
      },
    },
    Checkbox: {
      baseStyle: { control: { borderColor: "gray.400" } },
    },
    Table: {
      baseStyle: {
        table: {
          tbody: {
            tr: {
              _hover: {
                background: "blackAlpha.50",
              },
            },
          },
        },
      },
      variants: {
        noRowHighlight: {
          table: {
            borderCollapse: "separate",
            borderSpacing: "0 0.5rem",
            tbody: {
              tr: {
                _hover: {
                  background: "blackAlpha.0",
                },
              },
            },
          },
        },
      },
      sizes: {
        md: {
          th: {
            px: "3",
            py: "2",
            lineHeight: "4",
            fontSize: "xs",
          },
          td: {
            px: "4",
            py: "3",
            lineHeight: "5",
          },
          caption: {
            px: "4",
            py: "3",
            fontSize: "sm",
          },
        },
      },
    },
  },
};

export default theme;
